var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "8px",
    viewBox: "0 0 11 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ico_add") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Staff-Timesheets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "timesheet_advanced_options_custom_work",
    transform: "translate(-1059.000000, -314.000000)",
    fill: "#587E85",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Form",
    transform: "translate(471.000000, 178.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy-5",
    transform: "translate(30.000000, 115.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(558.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.97843154,1.25968926 C9.30106703,0.942605241 9.8025971,0.913197529 10.1582112,1.18631659 L10.1582112,1.18631659 L10.243702,1.26085571 C10.5906515,1.61604283 10.5847782,2.1884522 10.2296019,2.5375171 L10.2296019,2.5375171 L4.42739027,8.24038081 C4.07513766,8.58657233 3.51558852,8.58657019 3.16255734,8.23961015 L3.16255734,8.23961015 L0.269215073,5.37114627 C-0.089539581,5.01856147 -0.0897635038,4.44506532 0.268694761,4.09277491 C0.620951406,3.74657941 1.18050055,3.74657941 1.53313695,4.09314893 L1.53313695,4.09314893 L3.80800001,6.33802302 Z",
    id: "ico_add"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTick);
export default __webpack_public_path__ + "static/media/icon_tick.e4090322f19042086ca9fd0a9a703fa3.svg";
export { ForwardRef as ReactComponent };